import { render } from "./SearchByTextSubpage.vue?vue&type=template&id=54e81210&scoped=true"
import script from "./SearchByTextSubpage.vue?vue&type=script&lang=js"
export * from "./SearchByTextSubpage.vue?vue&type=script&lang=js"

import "./SearchByTextSubpage.vue?vue&type=style&index=0&id=54e81210&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e81210"]])

export default __exports__